import type { IxmAuthV1ApiKeyKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../util/routing/entity-paths';

export const API_KEY_BASE_PATH = getResolvedPath('/developer/api-key');

export const getApiKeyPath: EntityPathBuilder<IxmAuthV1ApiKeyKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return API_KEY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.clientId) {
        return undefined;
      }

      // TODO: allow for search string to open drawer for specific API key
      return undefined;
    }
  }
};
